/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from '@material-ui/icons/Refresh';
import { Action, Column, Options } from '@infotrack/presentacion-componentes/tabla';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import IGrupoActividadEconomica from 'Infotrack@Modelos/administracion/grupoActividadEconomica/entidades/grupoActividadEconomica';
import { BotonAgregar, BotonRefrescar } from 'Infotrack@Transversales/componentes/botonesAcciones';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const columnas = (
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string
): Array<Column<IGrupoActividadEconomica>> => [
    {
        title: formatMessage({ id: 'grupoActividadEconomica.codigoGrupoActividadEconomica' }),
        field: 'CodigoGrupoActividadEconomica',
    },
    {
        title: formatMessage({ id: 'grupoActividadEconomica.nombreGrupoActividadEconomica' }),
        field: 'NombreGrupoActividadEconomica',
    },
    {
        title: formatMessage({ id: 'grupoActividadEconomica.estadoGrupoActividadEconomica' }),
        field: 'EstadoGrupoActividadEconomica',
        type: 'boolean',
    },
];

export const acciones = (
    manejarFormulario: (tipoFormulario: TipoFormulario, grupoActividadEconomica?: IGrupoActividadEconomica) => void,
    cargarGrupoActividadEconomica: () => void,
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string,
    confirmarEliminacion: (grupoActividadEconomica: IGrupoActividadEconomica) => void
): Array<Action<IGrupoActividadEconomica>> => [
    {
        component: BotonAgregar,
        icon: () => <AddIcon />,
        onClick: () => manejarFormulario(TipoFormulario.Creacion, undefined),
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.agregar' }),
    },
    {
        icon: () => <EditIcon color="action" />,
        onClick: (_, value) => manejarFormulario(TipoFormulario.Edicion, value as IGrupoActividadEconomica),
        tooltip: formatMessage({ id: 'boton.editar' }),
    },
    {
        component: BotonRefrescar,
        icon: () => <RefreshIcon />,
        onClick: cargarGrupoActividadEconomica,
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.refrescar' }),
    },
    {
        icon: () => <DeleteIcon color="action" />,
        onClick: (_, value) => confirmarEliminacion(value as IGrupoActividadEconomica),
        tooltip: formatMessage({ id: 'boton.eliminar' }),
    },
];

export const opciones: Options<IGrupoActividadEconomica> = {
    maxBodyHeight: '50vh',
};
